import { request } from '../client';

export const getSearchSuggestions = (q) => request('/search/suggestions', { params: { q } });

export const getTrendingSearches = () => request('/search/trending');

export const search = (q, limit) => request('/search', { params: { q, limit } });
